import { Box, useTheme } from '@mui/material';
import { Link as RouterLink, To } from 'react-router-dom';

import { TYPOGRAPHY } from '@/theme';

import { Variants } from './constants';

type LinkProps = {
  to?: To;
  state?: any;
  onClick?: () => void;
  children: React.ReactNode;
  variant?: (typeof Variants)[keyof typeof Variants];
  inline?: boolean;
  color?: string;
  target?: string;
  rel?: string;
  textVariant?: keyof typeof TYPOGRAPHY;
};

export const Link = ({
  to,
  state,
  onClick = undefined,
  children,
  variant = Variants.CLASSIC,
  textVariant = 'body3SemiBold',
  inline = false,
  color = undefined,
  ...props
}: LinkProps) => {
  const theme = useTheme();

  if (!onClick && !to) return <>{children}</>;
  const isButton = !to;

  return (
    <Box
      component={to ? RouterLink : 'button'}
      onClick={onClick}
      tabIndex={0}
      to={to}
      state={state}
      {...props}
      sx={[
        isButton && styles.buttonReset,
        {
          ...theme.typography[textVariant],
          cursor: 'pointer',
          color: 'inherit',
          textDecoration: 'inherit',
          maxHeight: 'fit-content',
          maxWidth: 'fit-content',
        },
        variant === Variants.PLAIN && {
          color: 'inherit',
        },
        variant === Variants.CLASSIC && {
          color: 'secondary.main',
          ':hover': {
            textDecoration: 'underline',
          },
        },
        inline && {
          display: 'inline',
          fontSize: 'inherit !important',
          lineHeight: 'inherit !important',
        },
        color && {
          color,
        },
      ]}>
      {children}
    </Box>
  );
};

const styles = {
  buttonReset: {
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    textDecoration: 'inherit',
  },
};
